import {
	GetMemberProgramsV2Query,
	GetMemberProgramQuery,
} from '@src/graphqlTypes/catalogServiceTypes';
import { toInteger } from 'lodash';
import { convertCompletionTime } from '@guildeducationinc/catalog-tools';
import { isAffiliateProgram } from './offeringHitsUtility';
import { formatDate } from './dateUtility';
import { formatMoney } from './numberFormattingUtility';

const INTEREST_FACET_CATEGORY_ID = 4;

export const getEffort = (
	program: GetMemberProgramQuery['memberProgram'] | GetMemberProgramsV2Query['memberPrograms'][0]
) => {
	let hoursRange = '';
	const displayEffort = program?.minEffortHours || program?.maxEffortHours;

	if (!displayEffort) {
		return null;
	}

	if (
		program.minEffortHours &&
		program.maxEffortHours &&
		program.minEffortHours !== program.maxEffortHours
	) {
		hoursRange = `${program.minEffortHours}-${program.maxEffortHours}`;
	} else {
		hoursRange = `${program?.minEffortHours || program?.maxEffortHours}`;
	}

	return `${hoursRange} ${
		hoursRange.length !== 1 || toInteger(hoursRange) > 1 ? 'hours' : 'hour'
	} per week`;
};

export const getMemberPlanFundingLevel = (
	fundingLevel: GetMemberProgramQuery['memberProgram']['fundingLevel']
) => {
	if (!fundingLevel) return 'Funding unavailable';

	return fundingLevel === -1
		? '100% tuition paid'
		: `Up to ${formatMoney(fundingLevel)} tuition paid per year`;
};

export const formatStartDate = (
	program: GetMemberProgramQuery['memberProgram'] | GetMemberProgramsV2Query['memberPrograms'][0]
) => {
	const { startDate } = program?.nextDate || {};

	if (startDate) {
		return formatDate(startDate, {
			month: '2-digit',
			day: '2-digit',
			year: 'numeric',
			timeZone: 'UTC',
		});
	}

	if (isAffiliateProgram(program)) {
		return 'Flexible';
	}

	return 'Coming Soon';
};

export const getCompletionTime = (
	program: GetMemberProgramQuery['memberProgram'] | GetMemberProgramsV2Query['memberPrograms'][0]
) => {
	const displayCompletionTime =
		program?.minCompletionTimeDisplay &&
		program?.maxCompletionTimeDisplay &&
		program?.completionTimeDisplay;

	if (!displayCompletionTime) {
		return 'Length unavailable';
	}
	return `${convertCompletionTime(program.maxCompletionDays, program.minCompletionDays)}`;
};

export const getInterests = (program: GetMemberProgramsV2Query['memberPrograms'][0]) => {
	if (!program.facetOptions) return 'Interest unavailable';

	const interestFacetOptions = program.facetOptions.filter(
		facet => facet.facetCategoryId === INTEREST_FACET_CATEGORY_ID
	);

	if (!interestFacetOptions.length) return 'Interest unavailable';

	return interestFacetOptions.map(facet => facet.name).join(', ');
};
